<template>
  <section id="featured-brands" class="row text-center">
    <div id="featured-brands-carousel" class="marquee">
      <div class="carousel-inner">
        <div class="brand-group" v-for="(brand, index) in infiniteBrands" :key="index">
          <div class="brand">
            <img class="center-block" :src="brand.logo" :alt="brand.alt">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'brand-icon-marquee',

  props: {
    brandIcons: {
      type: Array,
      required: true
    }
  },

  computed: {
    // Duplicate the brandIcons list to ensure continuous scrolling
    infiniteBrands() {
      return this.brandIcons ? [...this.brandIcons, ...this.brandIcons] : [];
    }
  },
};
</script>

<style scoped lang="scss">
#featured-brands {
  #featured-brands-carousel {
    overflow: hidden;

    .carousel-inner {
      overflow: visible !important;
      display: flex;
      white-space: nowrap;
      animation: marquee 60s linear infinite;
      width: max-content;

      .brand-group {
        flex: 0 0 auto;
        display: inline-block;
        margin-right: 10px;
      }

      .brand {
        padding: 0;
      }

      img {
        border-radius: 5%;
        height: 150px;
        width: 150px;
      }
    }
  }
}

@keyframes marquee {
  0% {
    transform: translateX(0%);
  }

  100% {
    transform: translateX(-50%);
  }
}
</style>